// src/pages/introduction-menu.tsx

import React from 'react';
import { useVersionContext } from '../context/VersionContext';
import Chip from '@mui/material/Chip';
import { getAvailableIntroductions } from '../versions/versionRegistry';


// Sidebar - only renders when needed
interface IntroductionSidebarProps {
  items?: Array<{ name: string; path: string; deprecated?: string[] }>;  // Add ? for optional
  currentPath?: string;
}

const IntroductionSidebar: React.FC<IntroductionSidebarProps> = ({ items = [], currentPath }) => {
  const { currentVersion } = useVersionContext();
   const introItems = items.length > 0 ? items : getAvailableIntroductions(currentVersion.id).map(f => ({
       name: f.name,
       path: f.path,
       deprecated: f.deprecated,
     }));
  return (
    <div className="sidebar">
      <h6 className="m-t-10 m-b-0 m-l-20">Introduction</h6>
      <ul id="dynamic-tabs">
        {introItems.map((item) => (
          <li key={item.path} className={currentPath === `/introductions/${item.path}` ? "active" : ""}>
            <a href={`/introductions/${item.path}`} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}>
              {item.name}
              {item.deprecated?.includes(currentVersion.id) && (
                <Chip label="Deprecated" color="warning" size="small" />
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default IntroductionSidebar;
